import { Board } from "@sportactics/board-editing";
import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useUser } from "../user";
import { useFormationFirestorePersistence } from "./formation-firestore-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useFormationsFirestoreSWR() {
  const key = useKey();
  const fetcher = useFetcher();

  return useSWR(key, fetcher, { suspense: true });
}

export function getFormationsFirestoreSWRKey(
  userId: string,
): FormationsFirestoreSWRKey {
  return getSWRKey(SwrStore.FirestoreFormations, userId);
}

export type FormationsFirestoreSWRKey = readonly [SwrStore, string];

function useKey(): FormationsFirestoreSWRKey | null {
  const { user } = useUser();

  if (!user.authenticated) return null;
  return getFormationsFirestoreSWRKey(user.id);
}

function useFetcher(): (
  key: FormationsFirestoreSWRKey,
) => Promise<Record<string, Board>> {
  const { listFormations } = useFormationFirestorePersistence();

  return ([, userId]) => listFormations(userId);
}
